export default "__VITE_PUBLIC_ASSET__66611b3e__"